module.exports = __webpack_public_path__ + "img/laravel-fullstack-app9.b5bfb918.png";